// extracted by mini-css-extract-plugin
export default {"carousel":"CyfQn_5qySJnvS7ZkMWS","slide":"TV6hoLPVjVnEm8TbP8A1","paginator":"KPpZIiwxIQslqsrbydJc","page":"bOsb9SO5FGcflodpNKfC","selected":"QNcxx64OeVjM1pjyzzga"};